import { SupplierInfo } from '@/models/purchase-condition/selection/supplier-info';
import gql from 'graphql-tag';
import { executeQuery } from '../client';

const SUPPLIER_INFO_QUERY = gql`
  query($supplierCode: Int, $supplierCorpName: String) {
    supplierInfo(supplierCode: $supplierCode, supplierCorpName: $supplierCorpName) {
      supplierCode
      supplierCorpName
      purchaseConditionCount
      lastIntegrationDate
      lastSelectionDate
    }
  }
`;

export async function getSupplierInfo(filters: {
  supplierCode?: number;
  supplierCorpName?: string;
}): Promise<SupplierInfo | null> {
  const { supplierInfo } = await executeQuery<{ supplierInfo: SupplierInfo | null }>(SUPPLIER_INFO_QUERY, filters);

  return supplierInfo;
}
